<template>
	<v-container id="dashboard-view" fluid tag="section">
		<v-row>
			<v-col v-for="(chart, i) in charts" :key="`chart-${i}`" cols="12" lg="6">
				<material-chart-card :color="chart.color" :data="chart.data" :options="chart.options" :responsive-options="chart.responsiveOptions" :title="chart.title" :type="chart.type">
					<template #subtitle>
						<div class="font-weight-light text--secondary">
							<div v-html="chart.subtitle"></div>
							<div class="chart-hint">
								<div class="d-flex" v-for="(serie, j) in chart.series" :key="j">
									<v-icon class="ml-1" :color="serie.color" x-small>{{serie.icon}}</v-icon>
									<span>{{serie.title}}</span>
								</div>
							</div>
						</div>
					</template>
				</material-chart-card>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" md="12">
				<material-card icon="mdi-scale-balance" icon-small title="آمار سیستم در ماه جاری" color="#FD9A13">
					<v-card-text>
						<div>
							<v-row>
								<v-col cols="12" md="3">
									<div class="text-center">
										<h6 class="text-h6 grey--text">
											تعداد ثبت نام:
										</h6>
										<div class="text-h4 v-card__subtitle--material-stats">
											{{ monthStat.register }}
										</div>
										<h5 class="text-h6 grey--text">
											تعداد مشتری شده:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats">
											{{ monthStat.customer }}
										</div>
										<h5 class="text-h6 grey--text">
											تعداد مشتری ابری:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats">
											{{ monthStat.cloudCustomer }}
										</div>
										<h5 class="text-h6 grey--text">
											تعداد مشتری دائم:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats">
											{{ monthStat.permanentCustomer }}
										</div>
									</div>
								</v-col>
								<v-col cols="12" md="6">
									<div class="text-center">
										<h5 class="text-h6 grey--text">
											مجموع شارژ پیامک:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats mb-2">
											{{ monthStat.smsCharge.toString().toPriceFormat() }} تومان
										</div>
										<h5 class="text-h6 grey--text">
											تعداد پرونده وام:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats mb-2">
											{{ monthStat.userLoan }}
										</div>
									</div>
								</v-col>
								<v-col cols="12" md="3">
									<div class="text-center">
										<h5 class="text-h6 grey--text">
											مجموع فروش
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats mb-2">
											{{ monthStat.sale.toString().toPriceFormat() }} تومان
										</div>
										<h5 class="text-h6 grey--text">
											مجموع پورسانت:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats">
											{{ monthStat.commission.toString().toPriceFormat() }} تومان
										</div>
										<h5 class="text-h6 grey--text">
											سود:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats">
											{{ monthStat.profit.toString().toPriceFormat() }} تومان
										</div>
									</div>
								</v-col>
							</v-row>
						</div>
					</v-card-text>
				</material-card>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" md="12">
				<material-card icon="mdi-scale-balance" icon-small title="آمار کل سیستم" color="#FD9A13">
					<v-card-text>
						<div>
							<v-row>
								<v-col cols="12" md="3">
									<div class="text-center">
										<h6 class="text-h6 grey--text">
											تعداد ثبت نام:
										</h6>
										<div class="text-h4 v-card__subtitle--material-stats">
											{{ totalStat.register }}
										</div>
										<h5 class="text-h6 grey--text">
											تعداد مشتری شده:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats">
											{{ totalStat.customer }}
										</div>
										<h5 class="text-h6 grey--text">
											تعداد مشتری ابری:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats">
											{{ totalStat.cloudCustomer }}
										</div>
										<h5 class="text-h6 grey--text">
											تعداد مشتری دائم:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats">
											{{ totalStat.permanentCustomer }}
										</div>
									</div>
								</v-col>
								<v-col cols="12" md="6">
									<div class="text-center">
										<h5 class="text-h6 grey--text">
											مجموع شارژ پیامک:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats mb-2">
											{{ totalStat.smsCharge.toString().toPriceFormat() }} تومان
										</div>
										<h5 class="text-h6 grey--text">
											تعداد پرونده وام:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats mb-2">
											{{ totalStat.userLoan }}
										</div>
									</div>
								</v-col>
								<v-col cols="12" md="3">
									<div class="text-center">
										<h5 class="text-h6 grey--text">
											مجموع فروش
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats mb-2">
											{{ totalStat.sale.toString().toPriceFormat() }} تومان
										</div>
										<h5 class="text-h6 grey--text">
											مجموع پورسانت:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats">
											{{ totalStat.commission.toString().toPriceFormat() }} تومان
										</div>
										<h5 class="text-h6 grey--text">
											سود:
										</h5>
										<div class="text-h4 v-card__subtitle--material-stats">
											{{ totalStat.profit.toString().toPriceFormat() }} تومان
										</div>
									</div>
								</v-col>
							</v-row>
						</div>
					</v-card-text>
				</material-card>
			</v-col>
		</v-row>
		<v-row>
			<v-col v-for="({ actionIcon, actionText, ...attrs }, i) in systemStats" :key="i" cols="12" md="4" lg="3">
				<material-stat-card v-bind="attrs">
					<template #actions>
						<v-icon class="mr-2" small>{{ actionIcon  }}</v-icon>
						<div class="text-truncate" v-html="actionText"></div>
					</template>
				</material-stat-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	// Utilities
	import { get } from 'vuex-pathify'
	import Vue from 'vue'
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	const lineSmooth = Vue.chartist.Interpolation.cardinal({
		tension: 0,
	})

	export default {
		name: 'DashboardView',

		data: () => ({
			charts: {
				customer: {
					type: 'Bar',
					color: 'success',
					title: 'نمودار ثبت نام و مشتری',
					subtitle: 'نمودار ثبت نام و تبدیل به مشتری در یکسال گذشته ',
					series: [{
						icon: 'mdi-square',
						title: 'ثبت نام',
						color: 'black',
					}, {
						icon: 'mdi-square',
						title: 'مشتری',
						color: 'white',
					}],
					data: {
						labels: [],
						series: [[], []],
					},
					options: {
						lineSmooth,
						low: 0,
						high: 100000000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
						chartPadding: {
							top: 0,
							right: 0,
							bottom: 0,
							left: 0,
						},
						axisY: {
							offset: 50,
							labelInterpolationFnc: function (value) {
								return value
							},
						},
					},
				},
				sale: {
					type: 'Bar',
					color: 'info',
					title: 'نمودار فروش و پورسانت',
					subtitle: 'نمودار فروش و پورسانت ها در یکسال گذشته ',
					series: [{
						icon: 'mdi-square',
						title: 'فروش',
						color: 'black',
					}, {
						icon: 'mdi-square',
						title: 'پورسانت',
						color: 'white',
					}],
					data: {
						labels: [],
						series: [[], []],
					},
					options: {
						lineSmooth,
						low: 0,
						high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
						chartPadding: {
							top: 0,
							right: 0,
							bottom: 0,
							left: 0,
						},
						axisY: {
							offset: 90,
							labelInterpolationFnc: function (value) {
								return value.toString().toPriceFormat()
							},
						},
					},
				},
			},
			items: [],
			monthStat: {
				actionIcon: 'mdi-calendar',
				actionText: '',
				color: '#FD9A13',
				icon: 'mdi-account-cash',
				title: '',
				value: '',
				register: 0,
				customer: 0,
				cloudCustomer: 0,
				permanentCustomer: 0,
				sale: 0,
				commission: 0,
				profit: 0,
				smsCharge: 0,
				userLoan: 0
			},
			totalStat: {
				actionIcon: 'mdi-calendar',
				actionText: '',
				color: '#FD9A13',
				icon: 'mdi-account-cash',
				title: '',
				value: '',
				register: 0,
				customer: 0,
				cloudCustomer: 0,
				permanentCustomer: 0,
				sale: 0,
				commission: 0,
				profit: 0,
				smsCharge: 0,
				userLoan: 0
			},
			tabs: 0,
			systemStats: {
				pendingSmsPatterns: {
					actionIcon: 'mdi-tag',
					actionText: 'پیامک های در انتظار تائید',
					color: 'primary',
					icon: 'mdi-message-processing',
					title: 'تعداد',
					value: '',
				},
				unSeenedConsultants: {
					actionIcon: 'mdi-tag',
					actionText: 'درخواست مشاوره های در انتظار بررسی',
					color: 'primary',
					icon: 'mdi-room-service',
					title: 'تعداد',
					value: '',
				},
				tickets: {
					actionIcon: 'mdi-tag',
					actionText: 'تیکت جدید',
					color: 'success',
					icon: 'mdi-chat',
					title: 'تعداد',
					value: '',
				}
			},
		}),

		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				api.get('superadmin/dashboard/get', null)
					.then(
						response => {
							const customerChartData = { labels: [], series: [[], []] }
							let high1 = 0
							if (response.customerChart) {
								let series = [[], []]
								for (let i = 0; i < response.customerChart.length; i++) {
									customerChartData.labels.push(response.customerChart[i].month)
									series[0].push(response.customerChart[i].customer)
									series[1].push(response.customerChart[i].register)
									high1 = Math.max(high1, response.customerChart[i].register, response.customerChart[i].customer)
								}
								customerChartData.series = series
							}

							const saleChartData = { labels: [], series: [[], []] }
							let high2 = 0
							if (response.saleChart) {
								const series = [[], []]
								for (let i = 0; i < response.saleChart.length; i++) {
									saleChartData.labels.push(response.saleChart[i].month)
									series[0].push(response.saleChart[i].commission)
									series[1].push(response.saleChart[i].sale)
									high2 = Math.max(high2, response.saleChart[i].sale, response.saleChart[i].commission)
								}
								saleChartData.series = series
							}
							this.charts.customer.data = customerChartData
							this.charts.customer.options.high = high1
							this.charts.sale.data = saleChartData
							this.charts.sale.options.high = high2

							this.systemStats.tickets.value = '0'
							this.systemStats.pendingSmsPatterns.value = String(response.pendingSmsPatterns)
							this.systemStats.unSeenedConsultants.value = String(response.unSeenedConsultants)

							this.monthStat.register = response.currentMonthRegister
							this.monthStat.customer = response.currentMonthCustomer
							this.monthStat.cloudCustomer = response.currentMonthCloudCustomer
							this.monthStat.permanentCustomer = response.currentMonthPermanentCustomer
							this.monthStat.sale = response.currentMonthSale
							this.monthStat.commission = response.currentMonthCommission
							this.monthStat.profit = response.currentMonthProfit
							this.monthStat.smsCharge = response.currentMonthSmsCharge
							this.monthStat.userLoan = response.currentMonthUserLoan

							this.totalStat.register = response.totalRegister
							this.totalStat.customer = response.totalCustomer
							this.totalStat.cloudCustomer = response.totalCloudCustomer
							this.totalStat.permanentCustomer = response.totalPermanentCustomer
							this.totalStat.sale = response.totalSale
							this.totalStat.commission = response.totalCommission
							this.totalStat.profit = response.totalProfit
							this.totalStat.smsCharge = response.totalSmsCharge
							this.totalStat.userLoan = response.totalUserLoan
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
		},
	}
</script>
<style>
	svg.ct-chart-bar,
	svg.ct-chart-line {
		overflow: visible;
	}
	.ct-label.ct-label.ct-horizontal.ct-end {
		position: relative;
		justify-content: flex-end;
		text-align: right;
		transform-origin: 100% 0;
		transform: translate(-100%) rotate(-45deg);
		white-space: nowrap;
	}
	.ct-label.ct-vertical.ct-start {
		white-space: pre;
		transform: translateX(-5px);
	}
	.ct-series-a .ct-bar {
		/* Colour of your bars */
		stroke: white;
	}
	.ct-series-b .ct-bar {
		/* Colour of your bars */
		stroke: black;
	}
	.chart-hint {
		padding: 10px;
		background-color: #efefef;
		margin-bottom: 10px;
	}
</style>
